import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { MemberDetailInfo } from '../../../entities';
import { ME_UID } from '../../../constants';
import { AppRootContext } from '../../../bootstrap';
import { UtilService } from '../../../utils';

@Component({
    selector: 'styx-member-card',
    templateUrl: './member-card.component.html'
})
export class StyxMemberCardComponent implements OnInit {
    public loadingDone: boolean;

    @Input() member: MemberDetailInfo;

    constructor(private util:UtilService, private $http: HttpClient, private appRootContext: AppRootContext) {}

    ngOnInit() {
        this.loadMemberDetail();
    }

    private loadMemberDetail() {
        const memberId = this.member.uid === ME_UID ? this.appRootContext.me.uid : this.member.uid;
        this.$http
            .get(`/api/users/${memberId}/basic`)
            .pipe(
                finalize(() => {
                    this.loadingDone = true;
                })
            )
            .subscribe(
                (data: any) => {
                    this.member = Object.assign({}, this.member, data);
                },
                error => this.util.defaultErrorHandler()(error)
            );
    }
}
